module.exports = __webpack_public_path__ + "static/media/stir-fry-kale-pork.7be89641.jpg";